import { IconFreelancer, IconPiggyBank, IconStar, IconSupport } from '../../Icons';
import type { Reason } from '../../ReasonCard';

export const getVPReasons = (): ReadonlyArray<Readonly<Reason>> => [
    {
        heading: 'Leave it to the professionals',
        description:
            'Our global community of vetted, professional designers will create and deliver every pixel-perfect file and format you need.',
        icon: <IconFreelancer />,
    },
    {
        heading: 'Stick to your budget',
        description:
            'From minor tweaks to complete redesigns - we offer a range of services to grow your brand without breaking the bank.',
        icon: <IconPiggyBank />,
    },
    {
        heading: '24/7 customer support',
        description:
            'Our Customer Care Team are here to support you with your design or print journey - whenever you need it.',
        icon: <IconSupport />,
    },
    {
        heading: 'Design, print, store, deliver - all in one place',
        description:
            'All your designs are stored within your VistaPrint account, ready to print onto marketing materials, merch, packaging and more.',
        icon: <IconStar />,
    },
];
